import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "NewsSubscriptions",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const {
  getNewsSubscriptions,
  getNewsSubscriptionsError,
  getNewsSubscriptionsSuccess,
} = slice.actions;

reducerRegistry.register("newsSubscriptions", reducer);
